'use client';

import Link from 'next/link';
import { trackSectionCta } from '@/components/GoogleAnalytics';

export type CommunityServiceItem = {
  label: string;
  href?: string;
};

const SERVICES: CommunityServiceItem[] = [
  { label: 'Maratha Vadhu Var', href: '/anand-maratha' },
  { label: '96 Kuli Maratha Vadhu Var', href: '/anand-maratha' },
  { label: 'Nimbalkar Vadhu Var', href: '/nimbalkar-vadhu-var' },
  { label: 'Deokar Maratha Vadhu Var', href: '/deokar-maratha' },
  { label: 'Mali Vadhu Var', href: '/mali-vadhu-var' },
  { label: 'Brahmin Vadhu Var', href: '/marathi-brahmin-matrimony' },
  { label: 'Kokanastha Brahmin Vadhu Var', href: '/marathi-brahmin-matrimony' },
  { label: 'Kokanastha Maratha Vadhu Var', href: '/tawde-vivah' },
  { label: 'Tawde Vadhu Var', href: '/tawde-vivah' },
  { label: 'Koli Vadhu Var' },
  { label: 'Mahadev Koli Vadhu Var', href: '/mahadev-koli-matrimony' },
  { label: 'Aagri Koli Vadhu Var' },
  { label: 'Dhangar Vadhu Var', href: '/dhangar-matrimony' },
  { label: 'Vanjari Vadhu var', href: '/vanjari-matrimony' },
  { label: 'Bhandari Vadhu Var', href: '/bhandari-vadhu-var-suchak-mandal' },
  { label: 'Kitte Bhandari Vadhu Var', href: '/bhandari-vadhu-var-suchak-mandal' },
  { label: 'Hetkari Bhandari Vadhu Var', href: '/bhandari-vadhu-var-suchak-mandal' },
  { label: 'Kunbi Caste Vadhu Var', href: '/kunbi-matrimony' },
  { label: 'Banjara Vadhu Var' },
  { label: 'Dhor Kakkayya Vadhu Var', href: '/dhor-kakkayya-matrimony' },
  { label: 'Teli Samaj Vadhu Var' },
  { label: 'Leva Patil Vadhu Var', href: '/leva-patil' },
  { label: 'Marathi Match Finder' },
  { label: 'Marathi Vivah' },
  { label: 'Marathi Vivah Mandal' },
  { label: 'Marathi Vivah Sanstha' },
  { label: 'Marathi Vivah Mandal in Mumbai' },
  { label: 'Marathi Vivah Sanstha Pune', href: '/vadhu-var-suchak-mandal-pune' },
  { label: 'Free Marathi Vivah Sanstha' },
  { label: 'Marathi Grooms' },
  { label: 'Marathi grooms in USA' },
  { label: 'Jeevansathi Marathi Grooms' },
  { label: 'Marathi grooms in Mumbai' },
  { label: 'NRI Marathi Grooms', href: '/nri-marathi-grooms-in-usa' },
  { label: 'Marathi Grooms in Bangalore' },
];

const chipClass =
  'inline-flex items-center justify-center rounded-full bg-white px-4 py-2 text-center text-[14px] font-medium leading-[1.4] text-[#232323]';

type CommunityMatrimonyServicesProps = {
  title?: string;
  items?: readonly CommunityServiceItem[];
};

export default function CommunityMatrimonyServices({
  title = 'Community Marathi Matrimony Services',
  items = SERVICES,
}: CommunityMatrimonyServicesProps) {
  return (
    <section className="bg-white py-16 font-sans md:py-20">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-6xl text-center">
          <h2 className="mb-8 text-3xl font-bold text-gray-900">{title}</h2>
          <div className="flex flex-wrap justify-center gap-2.5">
            {items.map((service, index) =>
              service.href ? (
                <Link
                  key={`${service.label}-${index}`}
                  href={service.href}
                  onClick={() =>
                    trackSectionCta('click_community_keyword', 'community_services_section', service.label)
                  }
                  className={`${chipClass} border border-primary-200 transition-colors hover:border-primary-300 hover:bg-primary-50`}
                >
                  {service.label}
                </Link>
              ) : (
                <span key={`${service.label}-${index}`} className={`${chipClass} border border-gray-300`}>
                  {service.label}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
